import { render, staticRenderFns } from "./RevisionExitConfiguration.vue?vue&type=template&id=2d06a79f&scoped=true"
import script from "./RevisionExitConfiguration.vue?vue&type=script&lang=js"
export * from "./RevisionExitConfiguration.vue?vue&type=script&lang=js"
import style0 from "./RevisionExitConfiguration.vue?vue&type=style&index=0&id=2d06a79f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06a79f",
  null
  
)

export default component.exports